/*
 * Project 07 · MEND hub — sticky-nav + side-rail active-state
 *
 * Lightweight intersection observer:
 *   - tracks which .page-mend__phase-section is most visible
 *   - mirrors active class onto .page-mend__phase-nav-item-* (sticky nav)
 *     and .page-mend__rail-item-* (side rail) per phase key
 *   - hides chrome when above hero (scrollY < 600) or near final CTA
 *
 * Respects prefers-reduced-motion via CSS (transitions auto-zero out there).
 */
(function () {
  'use strict';

  const root = document.querySelector('.page-mend');
  if (!root) return;

  const phaseSections = root.querySelectorAll('[data-phase-section]');
  if (!phaseSections.length) return;

  const stickyNav = root.querySelector('[data-page-mend-stickynav]');
  const sideRail = root.querySelector('[data-page-mend-siderail]');
  const finalCta = root.querySelector('[data-page-mend-region="final-cta"]');

  let currentActive = null;

  function setActive(phaseKey) {
    if (phaseKey === currentActive) return;
    currentActive = phaseKey;
    const lowKey = phaseKey.toLowerCase();
    if (stickyNav) {
      stickyNav.querySelectorAll('.page-mend__phase-nav-item').forEach((el) => {
        el.classList.toggle('page-mend__phase-nav-item--active', el.dataset.phaseKey === phaseKey);
        if (el.dataset.phaseKey === phaseKey) {
          el.setAttribute('aria-current', 'location');
        } else {
          el.removeAttribute('aria-current');
        }
      });
    }
    if (sideRail) {
      sideRail.querySelectorAll('.page-mend__rail-item').forEach((el) => {
        el.classList.toggle('page-mend__rail-item--active', el.dataset.phaseKey === phaseKey);
      });
    }
  }

  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]) {
          setActive(visible[0].target.dataset.phaseSection);
        }
      },
      { threshold: [0.2, 0.4, 0.6], rootMargin: '-20% 0px -40% 0px' }
    );
    phaseSections.forEach((s) => obs.observe(s));
  }

  // Hide chrome above hero + near final CTA.
  function updateChromeVisibility() {
    const past = window.scrollY > 600;
    let near = false;
    if (finalCta) {
      const rect = finalCta.getBoundingClientRect();
      near = rect.top < window.innerHeight * 0.9;
    }
    const hidden = !past || near;
    if (stickyNav) stickyNav.classList.toggle('page-mend__phase-nav--hidden', hidden);
    if (sideRail) sideRail.classList.toggle('page-mend__phase-rail--hidden', hidden);
  }

  if (stickyNav || sideRail) {
    updateChromeVisibility();
    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateChromeVisibility();
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  // Smooth-scroll legend rows to the right offset (account for sticky header height).
  root.querySelectorAll('.page-mend__legend-row, .page-mend__phase-nav-item, .page-mend__rail-item').forEach((el) => {
    el.addEventListener('click', (e) => {
      const href = el.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const headerOffset = 140;
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top, behavior: prefersReduced ? 'auto' : 'smooth' });
    });
  });
})();
